import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Navbar,
  Button,
  Alignment,
  FocusStyleManager,
  OverflowList,
  Popover,
  Menu,
  MenuItem,
  Dialog,
  Classes,
  Intent,
  InputGroup,
} from '@blueprintjs/core';
import React from 'react';

import {
  setMenuSelected,
  setMenuSelected_2,
  setFocusFacility,
} from '../@redux/actions/menuAction';
import { unLogged } from '../@redux/actions/authAction';
import { menus } from '../constants/slug';
import styled from 'styled-components';
import ClearFix from 'components/elements/clearfix';
import AppList from 'components/app-list';
import { startsWith } from 'lodash';
import Permissions from 'react-redux-permissions';
import { createForm } from 'rc-form';
import { Row, Col } from 'reactstrap';
import { STYLE } from 'config';
import IconRequired from 'components/elements/required-icon';
import { userChangePassword } from 'api/userApi';
import { getApps } from 'api/appApi';
import * as _ from 'lodash';

import Message from 'rc-message';
import passwordValidator from 'custom-lib/password-validator';
import { COLOR } from 'config';

var schema = new passwordValidator();

schema
  .is()
  .min(8) // Minimum length 8
  .is()
  .max(100) // Maximum length 100
  .has()
  .uppercase() // Must have uppercase letters
  .has()
  .lowercase() // Must have lowercase letters
  .has()
  .digits() // Must have digits
  .has()
  .symbols(); // Should not have spaces

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  background: #fff;
  h2 {
    font-size: 16px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

const EllipsisButton = styled(Button)`
  margin: 0 8px;
  color: white !important;
  fontsize: 13 !important;
  flex: none;
  font-weight: 700;
  background: none !important;
  svg {
    color: white !important;
  }
`;

//boxShadow: 'inset 1px -1px 0px 9px grey;'

class HeaderComponent extends React.Component {
  state = {
    stationTypeList: [],
    selected: '',
    isOpenModal: false,
    domains: null,
    isShowApp: false,
  };

  async componentDidMount() {
    FocusStyleManager.onlyShowFocusOnTabs();
    let rs = await getApps();

    if (rs && rs.success) {
      // this.setState({ stationTypeList: rs.data });
      this.setState({
        domains: _.get(rs, ['data', 'domains']),
        isShowApp: _.get(rs, ['data', 'show']),
      });
    } else {
      this.setState({
        isShowApp: false,
      });
    }
  }

  handleMenuClick = (key, href) => {
    this.setState({ selected: key });
    this.props.setMenuSelected(key);
    this.props.setMenuSelected_2(null);
    this.props.setFocusFacility(null);
    this.props.history.push(href);
    this.forceUpdate();
  };

  handleLogout = () => {
    if (this.props.unLogged) this.props.unLogged();
  };

  submitChangePassword = async () => {
    this.props.form.validateFields(async (error, value) => {
      // value.district = _.get(value.district, 'value');
      // // value.securityLevel = _.get(value.securityLevel, 'value');
      // value.role = _.get(value.role, 'value');
      console.log(error, value, this.props.info);
      if (error) return;
      let res = await userChangePassword(
        _.result(this.props.info, '_id'),
        value
      );
      if (res.success) {
        this.setState({
          isOpenModal: false,
        });
        Message.success({ content: 'Thành Công' });
      }
      if (res.error) Message.error({ content: res.message });
    });
  };

  renderEllipseMenu(items) {
    if (items.length === 0) return null;
    return (
      <span key={items.length}>
        <Popover position='bottom' inline usePortal={true}>
          <EllipsisButton icon='more' minimal='true' />
          <Menu>
            {items.flat().map((item, index) => {
              const permissionRole = item.permissionRole;
              return (
                <Permissions key={`per_${index}`} allowed={[permissionRole]}>
                  <MenuItem
                    text={item.title}
                    key={item.href}
                    onClick={() => this.handleMenuClick(index, item.href)}
                  />
                </Permissions>
              );
            })}
          </Menu>
        </Popover>
      </span>
    );
  }

  render() {
    const pathname = this.props.location.pathname;
    const { getFieldProps, getFieldError, getFieldValue } = this.props.form;

    const appList = [
      {
        text: 'iLotusLand Monitoring',
        href: _.get(this.state, 'domains.ilotusland'),
        icon: (
          <img src={'/icons/logo-icon.png'} style={{ height: 25 }} alt='' />
        ),
      },
      {
        text: 'Quản lý cơ sở dữ liệu',
        href: _.get(this.state, 'domains.qlnt'),
        icon: (
          <img src={'/icons/logo-icon.png'} style={{ height: 25 }} alt='' />
        ),
      },
      {
        text: 'Phí bảo vệ môi trường',
        href: _.get(this.state, 'domains.billing'),
        icon: (
          <img src={'/icons/logo-icon.png'} style={{ height: 25 }} alt='' />
        ),
      },
    ].filter((item) => item.href);

    const menuItems = [
      ...menus().filter((menu) => !menu.showInMore),
      menus().filter((menu) => menu.showInMore),
    ];

    return (
      <div>
        <HeaderContainer>
          {this.state.isShowApp && <AppList list={appList} />}

          <img src='/ilotusland-logo.svg' alt='logo' style={{ height: 25 }} />

          <ClearFix width={8} />
          <div>
            <h2>Cổng Thông Tin Quản Lý Môi Trường</h2>
          </div>
          <div style={{ flex: 1 }} />
          <div style={{ display: 'inherit' }}>
            <a
              href='blank'
              style={{
                display: 'inline-flex',
                color: COLOR.SECOND_COLOR,
                textDecoration: 'underline',
              }}
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              {_.result(this.props.info, 'UserName')}
            </a>
            <ClearFix width={8} />
            <a
              href='blank'
              style={{
                display: 'inline-flex',
                color: COLOR.SECOND_COLOR,
                textDecoration: 'underline',
              }}
              onClick={(e) => {
                e.preventDefault();
                // this.handleLogout();
                this.setState({
                  isOpenModal: true,
                });
              }}
            >
              Đổi mật khẩu
            </a>
            <ClearFix width={8} />
            <a
              href='blank'
              style={{
                display: 'inline-flex',
                color: COLOR.SECOND_COLOR,
                textDecoration: 'underline',
              }}
              onClick={(e) => {
                e.preventDefault();
                this.handleLogout();
              }}
            >
              Thoát
            </a>

            <Dialog
              icon='info-sign'
              title='Đổi mật khẩu'
              isOpen={this.state.isOpenModal}
              onClose={() => {
                this.setState({
                  isOpenModal: false,
                });
              }}
              style={{
                width: 700,
              }}
              className={Classes.OVERLAY_SCROLL_CONTAINER}
              usePortal
              canOutsideClickClose
              canEscapeKeyClose
              hasBackdrop
            >
              <div
                style={{ whiteSpace: 'pre-line' }}
                className={`${Classes.DIALOG_BODY}`}
              >
                <div>
                  <Row key='passwordRow'>
                    <Col xs={4}>
                      <LabelContainer style={STYLE.REQUIREDFIELD}>
                        Mật khẩu hiện tại
                        <IconRequired />
                      </LabelContainer>
                    </Col>
                    <Col xs={4}>
                      <InputGroup
                        type='Password'
                        placeholder='******'
                        {...getFieldProps('Password', {
                          initialValue: '',
                          rules: [
                            {
                              required: true,
                              message: 'Vui lòng nhập Mật khẩu',
                            },
                            {
                              min: 6,
                              message: 'Mật khẩu độ dài ít nhất 6 ký tự',
                            },
                          ],
                        })}
                      />
                      <ErrorContainer>
                        {(getFieldError('Password') || []).join(', ')}
                      </ErrorContainer>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <LabelContainer style={STYLE.REQUIREDFIELD}>
                        Mật khẩu mới
                        <IconRequired />
                      </LabelContainer>
                    </Col>
                    <Col xs={4}>
                      <InputGroup
                        type='Password'
                        placeholder='******'
                        {...getFieldProps('NewPassword', {
                          initialValue: '',
                          rules: [
                            {
                              required: true,
                              message: 'Vui lòng nhập Mật khẩu',
                            },
                            // {
                            //   min: 6,
                            //   message: 'Mật khẩu độ dài ít nhất 6 ký tự'
                            // }
                            {
                              validator: (rule, val, callback) => {
                                const isStrongPassword = schema.validate(val);
                                if (!isStrongPassword)
                                  callback(
                                    new Error(
                                      'Mật khẩu phải ít nhất 8 ký tự, bao gồm ký tự Hoa, thường, số, ký tự đặc biệt'
                                    )
                                  );
                                callback();
                              },
                            },
                          ],
                        })}
                      />
                      <ErrorContainer>
                        {(getFieldError('NewPassword') || []).join(', ')}
                      </ErrorContainer>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <LabelContainer style={STYLE.REQUIREDFIELD}>
                        Xác nhận mật khẩu mới
                        <IconRequired />
                      </LabelContainer>
                    </Col>
                    <Col xs={4}>
                      <InputGroup
                        type='Password'
                        placeholder='******'
                        {...getFieldProps('PasswordRepeat', {
                          initialValue: '',
                          rules: [
                            {
                              validator: (rule, val, callback) => {
                                let pass = getFieldValue('NewPassword');
                                if (val !== pass)
                                  callback(
                                    new Error('Xác nhận mật khẩu không đúng')
                                  );
                                callback();
                              },
                            },
                          ],
                        })}
                      />
                      <ErrorContainer>
                        {(getFieldError('PasswordRepeat') || []).join(', ')}
                      </ErrorContainer>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className='bp3-dialog-footer'>
                <div className='bp3-dialog-footer-actions'>
                  <Button
                    style={{ backgroundColor: COLOR.SUCCESS }}
                    intent={Intent.SUCCESS}
                    onClick={this.submitChangePassword}
                  >
                    Thay đổi
                  </Button>
                </div>
              </div>
            </Dialog>
          </div>
        </HeaderContainer>
        <Navbar
          className='bp3'
          style={{
            background: COLOR.MENU_COLOR,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Navbar.Group
            className='bp3'
            align={Alignment.LEFT}
            style={{ backgroundColor: COLOR.MENU_COLOR, height: 35 }}
          >
            <OverflowList
              items={menuItems}
              observeParents={true}
              minVisibleItems={5}
              overflowRenderer={(items) => this.renderEllipseMenu(items.flat())}
              collapseFrom='end'
              visibleItemRenderer={(item, index) => {
                if (Array.isArray(item)) {
                  return this.renderEllipseMenu(item);
                }

                const { title, href, permissionRole } = item;

                let styleActive =
                  startsWith(pathname, href) ||
                  (href === '/biodiversity' && startsWith(pathname, '/species'))
                    ? { background: COLOR.MENU_ACTIVE_COLOR, color: '#FFFFFF' }
                    : { background: 'none', color: '#FFFFFF' };

                // console.log(permissionRole, "---permissionRole--");
                return (
                  <Permissions key={`per_${index}`} allowed={[permissionRole]}>
                    <Button
                      // large='true'
                      key={`${index}`}
                      style={{
                        ...styleActive,
                        fontSize: 13,
                        flex: 'none',
                        fontWeight: 700,
                      }}
                      minimal='true'
                      text={`${title}`}
                      onClick={() => this.handleMenuClick(index, href)}
                    />
                  </Permissions>
                );
              }}
            />
          </Navbar.Group>
        </Navbar>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
  info: state.auth.info,
});

const mapDispatchToProps = {
  setMenuSelected,
  unLogged,
  setMenuSelected_2,
  setFocusFacility,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(createForm()(HeaderComponent))
);



// WEBPACK FOOTER //
// ./src/layout/header.js